module.exports = __webpack_public_path__ + "static/media/CodeV.63ab1344.png";